import { createBrowserHistory } from 'history';
import { ROUTER_URL } from 'utils/enums';

export const customHistory = createBrowserHistory();

export const PUBLIC_URL_LIST = [ROUTER_URL.AUTH, ROUTER_URL.ERROR, ROUTER_URL.ERROR_NETWORK, ROUTER_URL.NOT_FOUND];
